import React from 'react';
import PropTypes from 'prop-types';
import styles from './ContextLinks.module.less';

function ContextLinks({ title, children }) {
  const count = React.Children.count(children);

  return (
    <div className={styles.root}>
      <h4 className={styles.title}>{title}: </h4>
      {React.Children.map(children, (child, i) => (
        <>
          {child}
          {i < count - 1 && ', '}
        </>
      ))}
    </div>
  );
}

ContextLinks.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string.isRequired,
};

export default ContextLinks;
